import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'
import { filtersQueryKeys } from './constants.js'

export const useCreateFilterQuery = (filter, customKey, entity, options) => {
  const queryFunction = async () => {
    const config = {
      method: 'post',
      data: filter
    }

    const { data } = await api('/api/filters', config)

    return data
  }

  return useQuery({
    queryKey: [filtersQueryKeys.CREATE_FILTER, customKey, entity],
    queryFn: queryFunction,

    ...options
  })
}
